// Кто пишет в общий чат из этого кабинета. У руководителя один id на весь
// аккаунт — сообщения из любой его вкладки и с любого телефона «свои».

export const OWNER_AUTHOR_ID = 'owner';

export function useChatMe(): string {
  return OWNER_AUTHOR_ID;
}

export function getChatMeId(): string {
  return OWNER_AUTHOR_ID;
}
